/**
 * Detect iOS devices (iPhone, iPad, iPod).
 * Includes iPad detection post-iPadOS 13 where navigator.platform is 'MacIntel'
 * but maxTouchPoints > 1.
 */
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

/**
 * Check if the app is running in standalone (installed PWA) mode.
 */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false
  // iOS standalone detection
  if ('standalone' in navigator && (navigator as { standalone: boolean }).standalone) {
    return true
  }
  // Standard display-mode detection
  return window.matchMedia('(display-mode: standalone)').matches
}

/**
 * Get the current display mode of the app.
 */
export function getDisplayMode(): 'standalone' | 'browser' {
  return isStandalone() ? 'standalone' : 'browser'
}
